/**
 * @generated SignedSource<<5347f212c1326652ffb0a0988293a41e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppTabMenu_tab$data = {
  readonly __typename: "JiraAppNavigationItem";
  readonly appId: string | null | undefined;
  readonly label: string | null | undefined;
  readonly sections: ReadonlyArray<{
    readonly label: string | null | undefined;
    readonly links: ReadonlyArray<{
      readonly iconUrl: string | null | undefined;
      readonly label: string | null | undefined;
      readonly styleClass: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_tab">;
  readonly " $fragmentType": "AppTabMenu_tab";
};
export type AppTabMenu_tab$key = {
  readonly " $data"?: AppTabMenu_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppTabMenu_tab">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "label"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppTabMenu_tab",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_tab"
    },
    {
      "kind": "ScalarField",
      "name": "appId"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "concreteType": "JiraAppSection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "concreteType": "JiraAppNavigationItemNestedLink",
          "kind": "LinkedField",
          "name": "links",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "iconUrl"
            },
            {
              "kind": "ScalarField",
              "name": "url"
            },
            {
              "kind": "ScalarField",
              "name": "styleClass"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAppNavigationItem"
};
})();

(node as any).hash = "0b52617895e2febba892c1e3d0914263";

export default node;
